export const NUMBER = 414;
export const NAME = `Combat card has no enemies listed`;
export const DESCRIPTION = ``;

export const INVALID = [
`_combat_

* on win

  Card

* on lose

  Card`,
];

export const VALID = [
`_combat_

- Skeleton Swordsman

* on win

  Card

* on lose

  Card`,
];
